export const TAX_RATE = 0.15;

export const PAYMENT_METHODS = {
    CREDIT_CARD: "card",
    POLI: "poli",
};
